import { render, staticRenderFns } from "./PatentSearch.vue?vue&type=template&id=39dbc2fc&scoped=true&"
import script from "./PatentSearch.vue?vue&type=script&lang=js&"
export * from "./PatentSearch.vue?vue&type=script&lang=js&"
import style0 from "./PatentSearch.vue?vue&type=style&index=0&id=39dbc2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbc2fc",
  null
  
)

export default component.exports